import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { XpressUserService, ConfigService, AppDataService } from 'app/services';
import { BetaFeature } from 'app/models/users/beta-feature';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import {
    DigitTypeEnum, FieldTypeEnum, LastActiveTypeModel, MenuPermissionConfig, RootMenuEnum,
    XpressUserProfile
} from 'app/models';
import * as moment from 'moment';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'home-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class CustomersComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public fieldTypeEnum = FieldTypeEnum;
    public xpressUsers: Array<any> = [];

    public specialDiscountTypeList: any = XpressUserProfile.SpecialDiscountTypeList;
    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
    public referredList = [
        { name: 'All', value: null },
        { name: 'Yes', value: true },
        { name: 'No', value: false }
    ];

    public selectedCustomer: any = undefined;
    public infoPopupCustomer: any = undefined;
    public showRemoveUserPopup: boolean = false;

    public statusFilterOptions = [
        { name: 'All', value: null },
        { name: 'Active', value: 1 },
        { name: 'Suspended', value: 2 },
        { name: 'Banned', value: 3 }
    ];

    public cols: any[] = [
        { field: 'StatusText', fieldType: FieldTypeEnum.Dropdown, model: 'statusFilter', options: this.statusFilterOptions,
            header: 'Status', width: '10%', disableSort: true, showSortIcon: false, placeholder: 'All', active: false },
        { field: 'Id', fieldType: FieldTypeEnum.InputNumber, model: 'userId', placeholder: 'Type here',
            header: 'User ID', width: '10%', disableSort: false, showSortIcon: false, active: false },
        { field: 'ShortUserName', fieldType: FieldTypeEnum.Inputs, model: 'userName', placeholder: 'Type here',
            header: 'Name', width: '20%', disableSort: false, showSortIcon: true, active: false },
        { field: 'Phone', fieldType: FieldTypeEnum.Inputs, model: 'phone', placeholder: 'Type here',
            header: 'Phone', width: '20%', disableSort: false, showSortIcon: true, active: false },
        { field: 'CreatedAt', fieldType: FieldTypeEnum.Calendar, model: 'signupDate', placeholder: 'Date',
            header: 'Sign up', width: '20%', disableSort: false, showSortIcon: true, active: false },
        { field: 'TotalSpend', fieldType: FieldTypeEnum.InputNumber, model: 'totalSpend', placeholder: 'Type here',
            header: 'Total Spend', width: '20%', disableSort: false, showSortIcon: true, active: false },
        { field: 'OrderCompletedCount', fieldType: FieldTypeEnum.InputNumber, model: 'orderCompletedCount', placeholder: 'Type here',
            header: 'Completed', width: '20%', disableSort: false, showSortIcon: true, active: false },
		{ field: 'SpecialDiscountType', fieldType: FieldTypeEnum.Dropdown, model: 'specialDiscountType', options: this.specialDiscountTypeList,
            header: 'Special Disc.', width: '20%', disableSort: false, showSortIcon: true, placeholder: 'Please select' },
        { field: 'WasReferred', fieldType: FieldTypeEnum.Dropdown, model: 'isReferred', options: this.referredList, placeholder: 'Please select',
            header: 'Referred?', width: '20%', take: 'obj', disableSort: false, showSortIcon: true, active: false },
        { field: 'LastActive', fieldType: FieldTypeEnum.Dropdown, model: 'lastActiveTypeObj', options: this.lastActiveTypeList, placeholder: 'Please select',
            header: 'Last Active', width: '20%', take: 'obj', disableSort: false, showSortIcon: true, active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();

    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
        digitType: DigitTypeEnum | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined, digitType: undefined };

    public userHeaderSearch: any = {
        statusFilter: null,
        userId: null,
        userName: null,
        signupDate: null,
        totalSpend: null,
        orderCompletedCount: null,
        isReferred: null,
        lastActiveTypeObj: null,
		specialDiscountType: null,
		phone: null
    };
    public arrayFilterLastLogin: any = [];

    public loading: boolean = true;

    public selectAll: boolean = false;

    public selectedUsers: Array<any> = [];

    private searchTimer: number = 0;

    public isShowBtnFeatures: boolean = false;

    public displayModal: boolean = false;

    public betaFeatureSourceList: any[] = [];
    public betaFeatureTargetList: any[] = [];

    public isLoadingBetaFeature: boolean = false;
    public isShowBtnBetaFeature: boolean = false;

    public visibleUserFilter: boolean = false;

    public displayModalSuspend: boolean = false;

    public showInfoPopup: boolean = false;
    public showEditFields: boolean = false;
    public suspendUser: {
        userId: number | null;
        userName: string | null;
    } = { userId: null, userName: null };

    public isVisibleCustomerInfo: boolean = false;

    public menuTitleName: string = 'All Users';
    public breadcrumbs: MenuItem[] = [];

    constructor(
        private messageService: MessageService,
        private xpressUserService: XpressUserService,
        public configService: ConfigService,
        public appData: AppDataService
    ) {
        this.handleInfoPopupHide = this.handleInfoPopupHide.bind(this);
    }

    ngOnInit(): void {
        if (!this.appData.isBoracayLocation || (this.menuPermissionActive === MenuPermissionConfig.BACK_OFFICE_USERS)) {
            this.breadcrumbs.push({ icon: 'icon_back_office' }, { label: 'Application' });
        }
        if (this.appData.isBoracayLocation && !this.menuPermissionActive) {
            this.breadcrumbs.push({ icon: 'icon_ops_tower' }, { label: 'Ops Tower' });
        }
        this.breadcrumbs.push({ label: 'Users' });
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.menuTitleName);
        }

        this.getXpressUsers(skip);
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public getXpressUsers(skip: number) {
        this.loading = true;
        const dto = {
            SearchName: this.filter.searchName,
            StartDateJoin: this.filter.startDateJoin,
            EndDateJoin: this.filter.endDateJoin,
            UserId: this.userHeaderSearch.userId,
            UserName: this.userHeaderSearch.userName,
            SignupDate: (!this.userHeaderSearch.signupDate) ? null : moment(this.userHeaderSearch.signupDate).format('YYYY-MM-DDTHH:mm:ss'),
            TotalSpend: this.userHeaderSearch.totalSpend,
            OrderCompletedCount: this.userHeaderSearch.orderCompletedCount,
            SpecialDiscountType: this.userHeaderSearch.specialDiscountType,
            LastActiveType: (this.userHeaderSearch.lastActiveTypeObj) ? this.userHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.userHeaderSearch.lastActiveTypeObj && this.userHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.userHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            IsReferred: (this.userHeaderSearch.isReferred) ? this.userHeaderSearch.isReferred.value : null,
            DigitType: this.filter.digitType,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
			TimeZoneOffset: Utils.getTimezoneOffset(),
			Phone: this.userHeaderSearch.phone,
            StatusFilter: this.userHeaderSearch.statusFilter
        };

        this.xpressUserService.getXpressUsers(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.xpressUsers = data.Items;

                this.xpressUsers.forEach(item => {
                    item.CreatedAt = moment(item.CreatedAt).format('DD MMM YYYY');
                    this.lastLoginDistinct(item.LastActive, item.LastActiveAt);

                    if (item.IsBanned) {
                        item.StatusText = 'Banned';
                        item.StatusColor = '#FFFFFF';
                        item.StatusBackColor = '#EB4236';
                    } else if (item.SuspendUntilDays > 0) {
                        item.StatusText = `Suspended ${item.SuspendUntilDays} Day${item.SuspendUntilDays > 1 ? 's' : ''}`;
                        item.StatusColor = '#FFFFFF';
                        item.StatusBackColor = '#F77F00';
                        item.IsSuspended = true;
                    } else {
                        item.StatusText = 'Active';
                        item.StatusColor = '#FFFFFF';
                        item.StatusBackColor = '#1CBA70';
                    }
                });
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public lastLoginDistinct(name: string, value: any) {
        const exists = this.arrayFilterLastLogin.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterLastLogin.push({
                name,
                value
            });
        }
    }

    onSelectionChange(value = []) {
        this.selectAll = value.length === this.totalRecords;
        this.selectedUsers = value;

        if (this.selectedUsers.length === 1) {
            this.isShowBtnFeatures = true;
        } else { this.isShowBtnFeatures = false; }
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getXpressUsers(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleFilterClear(): void {
        this.filter.searchName = '';

        this.handleFilterChange();
    }

    public showDisplayModal() {
        const betaFeature = new BetaFeature();

        this.isLoadingBetaFeature = true;
        this.isShowBtnBetaFeature = false;

        this.getXpressUser();

        this.betaFeatureSourceList = betaFeature.BetaFeatureList;

        this.displayModal = true;
    }

    public saveBetaFeatures() {
        const strBetaFeatures = this.betaFeatureTargetList.join(';');
        this.saveUserBetaFeatures(strBetaFeatures);
    }

    private saveUserBetaFeatures(strBetaFeatures: string) {
        this.isLoadingBetaFeature = true;
        this.isShowBtnBetaFeature = false;

        const dto = {
            UserId: this.selectedUsers[0].Id,
            BetaFeatures: strBetaFeatures
        };

        this.xpressUserService.updateUserBetaFeatures(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.isLoadingBetaFeature = false;
                    this.isShowBtnBetaFeature = true;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });

                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });

                this.isLoadingBetaFeature = false;
                this.isShowBtnBetaFeature = true;

                this.displayModal = false;
            })
            .catch(err => {
                this.isLoadingBetaFeature = false;
                this.isShowBtnBetaFeature = true;
                throw err;
            });
    }

    private getXpressUser() {
        const dto = {
            UserId: this.selectedUsers[0].Id
        };

        this.betaFeatureTargetList = [];

        this.xpressUserService.getXpressUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.isLoadingBetaFeature = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.isLoadingBetaFeature = false;
                this.isShowBtnBetaFeature = true;

                if (data.BetaFeatures !== '') {
                    this.betaFeatureTargetList = data.BetaFeatures;

                    this.betaFeatureTargetList.forEach((element) => {
                        const index = this.betaFeatureSourceList.indexOf(element);
                        if (index !== -1) {
                            this.betaFeatureSourceList.splice(index, 1);
                        }
                    });
                }

            })
            .catch(err => {
                this.isLoadingBetaFeature = false;
                throw err;
            });
    }

    public openUserFilter() {
        this.visibleUserFilter = !this.visibleUserFilter;
    }
    changedVisibleUserFilterEmit(value: any) {
        this.visibleUserFilter = value;
    }

    public showModalSuspend(user: any) {
        this.suspendUser = {
            userId: user.Id,
            userName: user.UserName
        };

        this.displayModalSuspend = !this.displayModalSuspend;
    }

    changedDisplayModalSuspendEmit(value: any) {
        this.displayModalSuspend = value;
    }

    public handleInfoPopupHide(): void {
        this.showInfoPopup = false;
    }

    public handlePopupLinkClick(customer: any, showEditFields: boolean): void {
        this.showEditFields = showEditFields;
        this.infoPopupCustomer = customer;
        this.isVisibleCustomerInfo = true;
    }
    changedVisibleCustomerInfoEmit(value: any) {
        this.isVisibleCustomerInfo = value;
    }

    onCustomerSuspendSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getXpressUsers(this.first);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer suspended successfully' });
    }

    onCustomerBanSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getXpressUsers(this.first);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer banned successfully' });
    }

    onCustomerLiftSuspensionSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getXpressUsers(this.first);
        this.messageService.add({ severity: 'success', summary: 'Suspension lifted', detail: 'Account successfully restored to Active.' });
    }

    onCustomerLiftBanSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getXpressUsers(this.first);
        this.messageService.add({ severity: 'success', summary: 'Ban lifted', detail: 'Account successfully restored to Active.' });
    }

    public handleRemoveUserPopup(user: any) {
        this.selectedCustomer = user;
        this.showRemoveUserPopup = true;
    }

    public removeUser() {
        const dto = {
            XpressUserId: this.selectedCustomer.Id
        };
        this.loading = true;
        this.xpressUserService.removeUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User has been deleted' });
                this.showRemoveUserPopup = false;
                this.getXpressUsers(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
    selectAllRows = false;

    selectAllRowsChanged(event: any) {
        this.xpressUsers.forEach(user => {
            user.selected = event.checked;
        });
    }

    getStatusStyles(status: string): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case 'Active':
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case 'Non active':
            case 'Offline':
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }
    getLastActiveStyles(lastActive: string): string {
        let textColor: string = '';

        if (lastActive === 'Never') {
            textColor = '#EB4236';
        } else {
            const today = new Date();
            const lastActiveDate = new Date(lastActive);
            const monthsDiff = (today.getFullYear() - lastActiveDate.getFullYear()) * 12 +
                (today.getMonth() - lastActiveDate.getMonth());
            if (monthsDiff > 3) {
                textColor = '#FFB100';
            }
        }

        return textColor;
    }

    public handleHeaderFilterChange(event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getXpressUsers(0);
            this.searchTimer = 0;
        }, 1500);
    }

    protected readonly RootMenuEnum = RootMenuEnum;
    protected readonly MenuPermissionConfig = MenuPermissionConfig;
}
